import { render, staticRenderFns } from "./ModalContent.vue?vue&type=template&id=b51d797c&scoped=true&"
import script from "./ModalContent.vue?vue&type=script&lang=js&"
export * from "./ModalContent.vue?vue&type=script&lang=js&"
import style0 from "./ModalContent.vue?vue&type=style&index=0&id=b51d797c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51d797c",
  null
  
)

export default component.exports